import React from "react";
import { TrendEvent } from "../../endpoints/results.type";
import { ExternalLink } from "lucide-react";

interface TrendEventDetailProps {
  event: TrendEvent;
  className?: string;
}

const formatEventDate = (isoDate: string) => {
  return new Date(isoDate).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const TrendEventDetail: React.FC<TrendEventDetailProps> = ({ event, className = "" }) => {
  return (
    <div className={className}>
      {event.image_url && (
        <img
          src={event.image_url}
          alt=""
          className="w-full h-40 object-cover rounded-md mb-3 bg-gray-100"
        />
      )}
      <p className="text-xs text-gray-500 mb-1">
        {formatEventDate(event.event_date)}
      </p>
      <h4 className="font-semibold text-gray-900 mb-2">
        {event.long_title}
      </h4>
      {event.description && (
        <p className="text-sm text-gray-600 mb-3 whitespace-pre-wrap">
          {event.description}
        </p>
      )}
      {event.links && event.links.length > 0 && (
        <div className="space-y-1">
          <span className="text-xs font-medium text-gray-500">
            External reporting
          </span>
          <ul className="space-y-1">
            {event.links.map((href, i) => (
              <li key={i}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1"
                >
                  <ExternalLink className="w-3 h-3 shrink-0" />
                  {href.length > 50 ? `${href.slice(0, 50)}…` : href}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TrendEventDetail;
